import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { T } from 'src/assets/i18n/translation-keys';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) { }

  transform(date: string, shortTimeDescription: boolean = false): string {
    if (moment(date).isValid()) {
      const seconds = Math.floor((+new Date() - +new Date(date)) / 1000);

      if (seconds < 29 && !shortTimeDescription) {
        return this.translateService.instant(T.common.time_ago.just_now);
      }

      const intervals = {
        year: 31536000,
        month_ago: 2592000,
        week_ago: 604800,
        days_ago: 86400,
        hour_ago: 3600,
        minute_ago: 60,
        seconds_ago: 1
      };

      let counter: number;

      for (const i in intervals) {
        counter = Math.floor(seconds / intervals[i]);

        if (counter > 0) {
          return shortTimeDescription
            ? this.returnShortDescription(counter, i)
            : this.returnLongDescription(counter, i);
        }
      }
    }

    return null;
  }

  private returnLongDescription(counter: number, interval: string): string {
    if (interval.toString() === 'year') return this.translateService.instant(T.common.time_ago.more_than_1_year_ago);

    return counter === 1 ?
      `${this.translateService.instant(T.common.time_ago[interval].one)}`
      : `${this.translateService.instant(T.common.time_ago[interval].many, { count: counter })}`
  }

  private returnShortDescription(counter: number, interval: string): string {
    const returnTypes = {
      year: "y",
      month_ago: "mo",
      week_ago: "w",
      days_ago: "d",
      hour_ago: "h",
      minute_ago: "min",
      seconds_ago: "s"
    };

    return `-${counter}${returnTypes[interval]}`;
  }
}
